import { previewRegex } from 'global/constants';

export const I_PHONE_8_PLUS_MODE = 'iPhone8Plus';
export const DESKTOP_MODE = 'desktop';

export const sizes = {
  desktop: {
    width: '100%',
    height: '100%',
  },
  iPhone8Plus: {
    width: '414px',
    height: '736px',
  },
};

export const getIsPreview = () => previewRegex.test(window.location.href);
